import { createWebHistory,createRouter } from "vue-router";
import Home from '../pages/Home/Home.vue';
import Auth from '../pages/Auth/Auth.vue';
import ShowEmployee from '../pages/Employee/Show.vue'
import ShowMinistryCompany from '../pages/Company/Show.vue'
import ShowCompany from '../pages/companies/Company/Show.vue'
import ShowTrainingCompany from '../pages/TrainingCompany/Show.vue'
import ShowTrainer from '../pages/Trainer/Show.vue'
import ShowCertificate from '../pages/Certificate/Show.vue'
import ShowLicense from '../pages/License/Show.vue'
import ShowTrainingProgram from  '../pages/TrainingProgram/Show.vue'
import ShowTraining from '../pages/Training/ShowTraining.vue'
const router = createRouter({
    history: createWebHistory(),
    routes:[
        {
            path:'/Auth',
            component:Auth,
        },
        {
            path:'/',
            component:Auth,
        },
        {
            path:'/home',
            component:Home,
        },
        {
            path:'/employee/:id',
            name:'show-employee',
            component:ShowEmployee,
        },
        {
            path:'/trainer/:id',
            name:'show-trainer',
            component:ShowTrainer,
        },
        {
            path:'/company/',
            name:'show-company',
            component:ShowCompany,
        },
        {
            path:'/Training/',
            name:'show-Training',
            component:ShowTraining,
        },
        {
            path:'/ministry/company/:id',
            name:'show-ministry-company',
            component:ShowMinistryCompany,
        },
        {
            path:'/training-company/:id',
            name:'show-training-company',
            component:ShowTrainingCompany,
        },
        {
            path:'/cerificate/:id',
            name:'show-cerificate',
            component:ShowCertificate,
        },
        {
            path:'/license/:id',
            name:'show-license',
            component:ShowLicense,
        },
        {
            path:'/training-program/:id',
            name:'show-training-program',
            component:ShowTrainingProgram,
        },
    ]
})

router.beforeEach((to, from, next) => {
    next();
    window.scrollTo(0, 0)
});

export default router
